import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Table } from 'antd'

import { BenefitInfo } from 'core/application/adminDashboard/benefitInfo'
import getTransactionsApi from 'core/application/employeeDashboard/summary/transactionHistory/getTransactions'

import Card from 'common/components/dataDisplay/Card'

import { formatMoney } from '../../../common'
import { parseZoneFormat } from '../../../common/dateFormatters'
import { useQueryRequest } from '../../../common/hooks'
import CardHeader from '../CardHeader'

import './TransactionHistory.less'

type TransactionHistoryProps = {
  planPeriodId: string
}

const TransactionHistory: React.FC<TransactionHistoryProps> = ({ planPeriodId }) => {
  const { t: translate } = useTranslation('ee-dashboard')

  const [transactionHistory, isLoading, sendGetTransactionHistory] = useQueryRequest([])

  useEffect(() => {
    ;(async () => {
      await sendGetTransactionHistory(() => getTransactionsApi(planPeriodId))
    })()
  }, [planPeriodId])

  const columns: any[] = [
    {
      title: translate('transaction-history.date-label'),
      dataIndex: 'date',
      key: 'date',
      render: (item: Date) => {
        return parseZoneFormat(item)
      },
      className: 't-date',
    },
    {
      title: translate('transaction-history.event-type-label'),
      dataIndex: 'eventType',
      key: 'eventType',
      render: (item: any) => {
        return item.name
      },
      className: 't-eventType',
    },
    {
      title: translate('transaction-history.amount-label'),
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-amount',
    },
    {
      title: translate('transaction-history.available-allowance-label'),
      dataIndex: 'availableAllowance',
      key: 'availableAllowance',
      align: 'right',
      render: (item: number) => {
        return formatMoney(item)
      },
      className: 't-availableAllowance',
    },
  ]

  return (
    <Card title={<CardHeader title={translate('transaction-history.title')} />} className="transaction_history_summary">
      <Table
        rowKey={(key) => key.index}
        dataSource={transactionHistory}
        loading={isLoading}
        columns={columns}
        scroll={{ x: 'auto' }}
      />
    </Card>
  )
}

export default TransactionHistory
